// 扫码进入小程序的类型
export enum ScanQrCodeType {
  /** 准考证 */
  Examinee = "0",
  /**考场 */
  Examplace = "1",
  /**考点 */
  Examsite = "2",
  /**首页 */
  Home = "3",
  /**扫码登录 */
  PcLogin = "4",
  /**查成绩 */
  QueryScore = "5",
  // 防伪码
  AntiCounterfeitingCode = "6",
}
